<template lang="pug">
  .message-confirm-modal
    b-modal(ref="modal" size="lg" no-close-on-backdrop no-close-on-esc @ok="submit")
      div(slot="modal-title")
        span.message-confirm-modal-title(v-if="validated == true") 以下の内容でメッセージを送信します。よろしいですか？
        span.message-confirm-modal-title(v-else) メッセージプレビュー

      .message-confirm-modal-body
        .body.d-flex.flex-column
          .message-text
            SendMessagePreview(v-model="functionContents" :replyLimit="_replyLimit")

      .message-confirm-modal-footer(slot="modal-footer" slot-scope="{ ok, cancel }")
        .file(v-if="0 < files.length")
          span.title 添付ファイル（{{ files.length }}）
          button.btn.preview-btn(@click="onPreview") プレビュー
        .buttons
          button.btn.modal-ok-btn(v-if="validated == true" type="button" @click="ok()") OK
          button.btn.modal-cancel-btn(v-if="validated == true" type="button" @click="cancel()") キャンセル
          button.btn.modal-cancel-btn(v-else type="button" @click="cancel()") 閉じる
</template>

<script lang="ts">
import { Component, Prop, Ref, Vue } from "vue-property-decorator";
import { userStore } from "@/store/store";
import { SendMessageFunction } from "@/commons/models/Message";
import SendMessagePreview from "@/pc/basics/SendMessagePreview.vue";

/**
 * ### メッセージ送信プレビューモーダル
 */
@Component({
  components: {
    SendMessagePreview
  }
})
export default class SendMessagePreviewModal extends Vue {
  /** ファイルプレビューモーダル */
  @Ref() modal!: any;

  @Prop({
    default: () => {
      return [];
    }
  })
  files!: [];

  /** 表示対象のメッセージ */
  functionContents: SendMessageFunction | null = null;
  /** 表示する情報がバリデーション済みか */
  validated: boolean = false;
  /** 宛先CSSクラス */
  isAddressOpen: boolean = false;

  /**
   * ### モーダル表示
   */
  public show(functionContents: SendMessageFunction, validated: boolean): void {
    this.functionContents = functionContents;
    this.validated = validated;

    this.modal.show();

    return;
  }

  /**
   * ### メッセージ返信可能期限を返す
   */
  get _replyLimit(): number {
    return userStore.facility.messageSettings.replyLimit;
  }

  /**
   * ### プレビューボタン押下イベント
   */
  public onPreview(): void {
    this.$emit("preview");
    return;
  }

  /**
   * ### 送信するボタン押下イベント
   */
  public submit(): void {
    this.$emit("submit");
    return;
  }
}
</script>
